var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 111 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Add_Folder_70768",
    "data-name": "noun_Add Folder_70768",
    transform: "translate(-8 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M84.967,54a20.967,20.967,0,1,0,20.967,20.967A20.99,20.99,0,0,0,84.967,54Zm0,37A16.033,16.033,0,1,1,101,74.967,16.052,16.052,0,0,1,84.967,91Z",
    transform: "translate(13.067 8.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M91.733,70.633H85.567V64.467a2.467,2.467,0,1,0-4.933,0v6.167H74.467a2.467,2.467,0,1,0,0,4.933h6.167v6.167a2.467,2.467,0,1,0,4.933,0V75.567h6.167a2.467,2.467,0,0,0,0-4.933Z",
    transform: "translate(14.933 9.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M21.567,96.6H71.979a2.456,2.456,0,1,0,0-4.912H21.567c-5,0-8.633-4.086-8.633-6.837V59.756c0-7.1,4.7-8.6,8.633-8.6H46.2c6.411,0,9.2-2.925,11.45-5.278,1.84-1.927,3.17-3.318,6.491-3.318h33.9a8.619,8.619,0,0,1,8.627,8.592v6.606a2.467,2.467,0,0,0,4.933,0V41.329a13.549,13.549,0,0,0-13.562-13.5h-33.9c-3.223,0-4.481-1.5-6.382-3.781C55.509,21.352,52.71,18,46.2,18H21.567C13.2,18,8,23.174,8,31.5V84.851C8,90.394,13.805,96.6,21.567,96.6Zm0-73.687H46.2c4.195,0,5.771,1.885,7.765,4.273,2.067,2.473,4.64,5.552,10.176,5.552h33.9a8.617,8.617,0,0,1,8.6,7.982,13.53,13.53,0,0,0-8.6-3.069h-33.9c-5.439,0-8,2.686-10.066,4.847-2,2.1-3.582,3.749-7.875,3.749H21.567A14.855,14.855,0,0,0,12.933,48.8V31.5C12.933,24.4,17.631,22.913,21.567,22.913Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFolder);
export default __webpack_public_path__ + "static/media/upload-folder.ccfaf2e7.svg";
export { ForwardRef as ReactComponent };